var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-linkedin';
                    var viewUrl = 'sprite.svg#view-icon-linkedin';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-linkedin#icon-linkedin';
                            viewUrl = 'sprite.svg?icon-linkedin#view-icon-linkedin';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 19.1 19.1',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };